import qs from 'qs'

export const STRAPI_BASE_URL =
  process.env.REACT_APP_STRAPI_ENDPOINT || 'http://localhost:1337'

export async function getFgEdificioCorporativos() {
  try {
    const query = qs.stringify({
      populate: '*',
    })

    const res = await fetch(`${STRAPI_BASE_URL}/api/fg-edificio-corporativos?${query}`)
    const data = await res.json()

    return data?.data?.[0] || null
  } catch (err) {
    console.error('Error cargando fg-edificio-corporativos:', err)
    return null
  }
}
